import React from "react";
import "../../styles.css";
import "./programs_.css";
import { programsContent } from "../../constants/data";
import { Countdown, ScrollToTop } from "../../components";

const Programs = () => {
  return (
    <>
      {/* title */}
      <section className="titleSection pt-6 pb-5">
        <div className="container pt-3">
          <div className="row">
            <div className="col-12">
              <h1 className="supportText text-center">Programs</h1>
            </div>
          </div>
        </div>
      </section>

      {/* program list */}
      <section className="programList">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ol type="1">
                {programsContent.list.map((program, index) => (
                  <li>
                    <h3>{program.title}</h3>

                    <p>{program.description}</p>
                  </li>
                ))}
              </ol>
            </div>
          </div>
        </div>
      </section>
      <Countdown />
      <ScrollToTop />
    </>
  );
};

export default Programs;
